module.exports = __webpack_public_path__ + "img/level_0_img_2.7ed9e340.jpeg";